import type { StateStorage } from "zustand/middleware";

import { browserLocalStorage } from "@/react/lib/browserStorage";

export const dedupedDockStorage: StateStorage = {
  getItem: name => browserLocalStorage.getItem(name),
  setItem: (name, value) => {
    if (browserLocalStorage.getItem(name) === value) return;
    browserLocalStorage.setItem(name, value);
  },
  removeItem: name => browserLocalStorage.removeItem(name),
};
